import React, { Component } from 'react'
import CustomAlert from '../../components/shared/CustomAlert'
import { toJS } from 'mobx'
import DashboardLayout from '../../components/Admin/DashboardLayout'
import { MDBContainer } from 'mdb-react-ui-kit'
import { toast } from 'react-toastify'
import PageHeading from './../../components/shared/PageHeading.component'
import { UIInput, UIDatePickerInput } from './../../components/forms/form-fields'
import { MDBRow, MDBBtn, MDBCol, MDBInput } from 'mdb-react-ui-kit'
import { SystemSettingFactory } from './../../shared/factories'
import moment from 'moment'
import LoadingSpinner from './../../components/shared/LoadingSpinner.component'

function convertDate(value) {
  value = value && typeof value === 'string' ? value.split('T')[0] : value

  if (value && typeof value === 'string') return moment(value, 'YYYY-MM-DD').toDate()
  if (value && typeof value === 'object') return value
}

async function getSettingInstance() {
  return (
    (
      await SystemSettingFactory.search({
        search: { setting_key: 'agents---eo-policy' },
      })
    )?.models || []
  ).shift()
}

function getIsValid(policy) {
  // Only use the provided eo, do NOT close over eopolicy state!
  const isValid = !!(
    policy?.carrier_name &&
    policy?.per_coverage_amt &&
    policy?.agg_coverage_amt &&
    policy?.eopolicy_num &&
    policy?.effective_date &&
    policy?.expiration_date
  )

  if (isValid) return getIsDatesValid(policy)

  return false
}

function getIsDatesValid(policy) {
  let effective_date = policy?.effective_date,
    expiration_date = policy?.expiration_date

  effective_date =
    effective_date && typeof effective_date === 'string'
      ? moment(`${effective_date}`.split('T').shift()).toDate()
      : effective_date
  expiration_date =
    expiration_date && typeof expiration_date === 'string'
      ? moment(`${expiration_date}`.split('T').shift()).toDate()
      : expiration_date

  if (effective_date && expiration_date) {
    if (typeof effective_date === 'object' && typeof expiration_date === 'object') {
      if (effective_date.getTime() >= expiration_date.getTime()) return false
    }
  }

  return true
}

class AdminEOPolicyPage extends Component {
  async fetchGroupPolicy() {
    this.setState({ isLoading: true })
    const Setting = await getSettingInstance(),
      policy = toJS(Setting.get('setting_value'))

    this.setState({
      Setting,
      policy: policy ? (typeof policy === 'string' ? JSON.parse(policy) : policy) : {},
      isLoading: false,
    })
  }

  currencyKeypress(event) {
    const { policy } = this.state

    let name = event.target.name,
      isNumeric = event.which >= 48 && event.which <= 57,
      isDecimal = parseInt(event.which) === 46,
      decimalExists = `${policy?.[name]}`.indexOf('.') > -1

    if ((isNumeric || isDecimal) && !decimalExists) return true

    if (isNumeric && decimalExists && `${policy?.[name]}`.split('.')[1].length < 2) return true

    event.preventDefault()
    return false
  }

  async savePolicy() {
    const { Setting, policy } = this.state

    this.setState({ isSaving: true })

    return new Promise(async (resolve, reject) => {
      try {
        Setting.set('setting_value', JSON.stringify(policy))
        await Setting.save()
        this.setState({ Setting, isSaving: false })
        resolve()
      } catch (ex) {
        reject(`${ex}`)
        this.setState({ isSaving: false })
      }
    })
  }

  constructor(props) {
    super(props)
    this.state = {
      isLoading: true,
      isSaving: false,
      policy: null,
      Setting: null,
      showValidity: {
        carrier_name: false,
      },
    }
  }

  componentDidMount() {
    this.fetchGroupPolicy()
  }

  render() {
    const { isLoading, isSaving, Setting, policy, showValidity } = this.state

    const minDate = moment(
        policy?.effective_date && typeof policy?.effective_date === 'object' ? policy?.effective_date : new Date()
      )
        .add(1, 'days')
        .toDate(),
      isValid = getIsValid(policy),
      isDatesValid = getIsDatesValid(policy),
      EffectiveDate = React.forwardRef((props, ref) => <MDBInput label='Effective Date' ref={ref} {...props} />),
      ExpiryDate = React.forwardRef((props, ref) => <MDBInput label='Expiration Date' ref={ref} {...props} />),
      effective_date =
        policy && convertDate(policy?.effective_date)
          ? moment(convertDate(policy?.effective_date)).format('MM/DD/YYYY')
          : policy?.effective_date,
      expiration_date =
        policy && convertDate(policy?.expiration_date)
          ? moment(convertDate(policy?.expiration_date)).format('MM/DD/YYYY')
          : policy?.expiration_date

    return (
      <DashboardLayout>
        <main id='AdminEOPolicyPage' className='mainSection pb-5'>
          <MDBContainer fluid className='mt-4'>
            <PageHeading
              label='E&O Policy Administration'
              url={this.props?.match?.url}
              from={this.props?.location?.state?.from}
              goTo={url => this.props.history.push(url, { from: '/admin-referrals' })}
            />
          </MDBContainer>

          <form className='content-wrapper container'>
            <MDBRow>
              {Setting && !isLoading ? (
                <MDBCol size='12' className='pt-4'>
                  <MDBRow>
                    <MDBCol size='12' sm='6' className='mb-4'>
                      <div
                        className={[
                          'input-wrapper input-select-wrapper',
                          !policy?.carrier_name ? 'active-input' : '',
                        ].join(' ')}
                      >
                        <UIInput
                          label='E&O Policy Carrier'
                          name='carrier_name'
                          value={policy?.carrier_name}
                          onChange={event => {
                            policy.carrier_name = event.target.value
                            Setting.set('setting_value', JSON.stringify(policy))
                            this.setState(prevState => ({
                              ...prevState,
                              Setting,
                              policy,
                              showValidity: {
                                ...showValidity,
                                carrier_name: !policy?.carrier_name,
                              },
                            }))
                          }}
                          rules={{ required: true }}
                          required
                          showValidity={showValidity?.carrier_name}
                        />
                      </div>
                    </MDBCol>
                    <MDBCol size='12' sm='6' className='mb-4'>
                      <div
                        className={[
                          'input-wrapper',
                          !policy?.eopolicy_num ? 'active-input' : '',
                          !policy?.carrier_name ? 'disabled-input' : '',
                          !policy?.eopolicy_num ? 'invalid-input' : '',
                        ].join(' ')}
                      >
                        <UIInput
                          label='E&O Policy Number'
                          name='eopolicy_num'
                          disabled={!policy?.carrier_name}
                          value={policy?.eopolicy_num}
                          onChange={event => {
                            policy.eopolicy_num = event.target.value
                            Setting.set('setting_value', JSON.stringify(policy))
                            this.setState(prevState => ({
                              ...prevState,
                              Setting,
                              policy,
                              showValidity: {
                                ...showValidity,
                                eopolicy_num: !policy?.eopolicy_num,
                              },
                            }))
                          }}
                          rules={{ required: true }}
                          required
                          showValidity={showValidity?.eopolicy_num}
                        />
                      </div>
                    </MDBCol>
                    <MDBCol size='12' sm='6' className='mb-4'>
                      <div
                        className={[
                          'input-wrapper',
                          !policy?.per_coverage_amt ? 'active-input' : '',
                          !policy?.eopolicy_num ? 'disabled-input' : '',
                          !policy?.per_coverage_amt ? 'invalid-input' : '',
                        ].join(' ')}
                      >
                        <UIInput
                          label='Coverage Amount (each occurrence)'
                          name='per_coverage_amt'
                          disabled={!policy?.carrier_name || !policy?.eopolicy_num}
                          value={policy?.per_coverage_amt}
                          onChange={event => {
                            const value = event.target.value
                            policy.per_coverage_amt = value
                            Setting.set('setting_value', JSON.stringify(policy))
                            this.setState(prevState => ({
                              ...prevState,
                              Setting,
                              policy,
                              showValidity: {
                                ...showValidity,
                                per_coverage_amt: !value || value > 999999999,
                              },
                            }))
                          }}
                          rules={{
                            required: true,
                            maxValue: 999999999,
                            minValue: 1,
                          }}
                          showValidity={showValidity?.per_coverage_amt}
                          onKeyPress={evt => this.currencyKeypress(evt)}
                          required
                        />
                      </div>
                    </MDBCol>
                    <MDBCol size='12' sm='6' className='mb-4'>
                      <div
                        className={[
                          'input-wrapper',
                          !policy?.agg_coverage_amt ? 'active-input' : '',
                          !policy?.per_coverage_amt ? 'disabled-input' : '',
                          !policy?.agg_coverage_amt ? 'invalid-input' : '',
                        ].join(' ')}
                      >
                        <UIInput
                          label='Coverage Amount (Aggregate)'
                          name='agg_coverage_amt'
                          disabled={!policy?.carrier_name || !policy?.eopolicy_num || !policy?.per_coverage_amt}
                          value={policy?.agg_coverage_amt}
                          onChange={event => {
                            const value = event.target.value
                            policy.agg_coverage_amt = value
                            Setting.set('setting_value', JSON.stringify(policy))
                            this.setState(prevState => ({
                              ...prevState,
                              Setting,
                              policy,
                              showValidity: {
                                ...showValidity,
                                agg_coverage_amt: !value || value > 999999999,
                              },
                            }))
                          }}
                          rules={{
                            required: true,
                            maxValue: 999999999,
                            minValue: 1,
                          }}
                          showValidity={showValidity?.agg_coverage_amt}
                          onKeyPress={evt => this.currencyKeypress(evt)}
                          required
                        />
                      </div>
                    </MDBCol>
                    <MDBCol size='12' sm='6' className='mb-4'>
                      <div
                        className={[
                          'input-wrapper',
                          policy?.eopolicy_num &&
                          policy?.carrier_name &&
                          policy?.per_coverage_amt &&
                          policy?.agg_coverage_amt &&
                          !effective_date
                            ? 'active-input'
                            : '',
                          !policy?.agg_coverage_amt ? 'disabled-input' : '',
                          !effective_date || !isDatesValid ? 'invalid-input' : '',
                        ].join(' ')}
                      >
                        <UIDatePickerInput
                          showYearDropdown
                          yearDropdownItemNumber={100}
                          scrollableYearDropdown
                          disabled={
                            !policy?.eopolicy_num ||
                            !policy?.carrier_name ||
                            !policy?.per_coverage_amt ||
                            !policy?.agg_coverage_amt
                          }
                          selected={effective_date ? moment(effective_date, 'MM/DD/YYYY').toDate() : null}
                          dateFormat='MM/dd/yyyy'
                          name='effective_date'
                          onChange={event => {
                            const curr = policy?.effective_date,
                              change = event.target.value

                            policy.effective_date = change
                            showValidity.effective_date = !(
                              (curr && !change) ||
                              (!curr && change) ||
                              moment(convertDate(curr)).format('MM/DD/YYYY') !==
                                moment(convertDate(change)).format('MM/DD/YYYY')
                            )
                            Setting.set('setting_value', JSON.stringify(policy))
                            this.setState({ Setting, showValidity, policy })
                          }}
                          showValidity={showValidity?.effective_date}
                          rules={{ required: true }}
                          required
                          customInput={<EffectiveDate />}
                        />
                        {!isDatesValid ? (
                          <small className='text--red'>
                            <strong>Expiration date must occur after Effective date.</strong>
                          </small>
                        ) : (
                          <></>
                        )}
                      </div>
                    </MDBCol>
                    <MDBCol size='12' sm='6' className='mb-4'>
                      <div
                        className={[
                          'input-wrapper',
                          !expiration_date ? 'active-input' : '',
                          !policy?.effective_date ? 'disabled-input' : '',
                          !expiration_date || !isDatesValid ? 'invalid-input' : '',
                        ].join(' ')}
                      >
                        <UIDatePickerInput
                          showYearDropdown
                          yearDropdownItemNumber={100}
                          scrollableYearDropdown
                          disabled={
                            !policy?.eopolicy_num ||
                            !policy?.carrier_name ||
                            !policy?.per_coverage_amt ||
                            !policy?.agg_coverage_amt ||
                            !policy?.effective_date
                          }
                          selected={expiration_date ? moment(expiration_date, 'MM/DD/YYYY').toDate() : null}
                          dateFormat='MM/dd/yyyy'
                          name='expiration_date'
                          onChange={event => {
                            const curr = policy?.expiration_date,
                              change = event.target.value

                            policy.expiration_date = change
                            showValidity.expiration_date = !(
                              (curr && !change) ||
                              (!curr && change) ||
                              moment(convertDate(curr)).format('MM/DD/YYYY') !==
                                moment(convertDate(change)).format('MM/DD/YYYY')
                            )
                            Setting.set('setting_value', JSON.stringify(policy))
                            this.setState({ Setting, showValidity, policy })
                          }}
                          showValidity={showValidity?.expiration_date}
                          rules={{ required: true }}
                          required
                          minDate={minDate}
                          customInput={<ExpiryDate />}
                        />
                      </div>
                    </MDBCol>
                    <MDBCol size='12' className='mb-4'>
                      <MDBBtn
                        type='button'
                        size='sm'
                        block
                        color='success'
                        disabled={!isValid || isSaving || isLoading || Setting?.hasChanged === false}
                        className='submit-btn'
                        onClick={() => {
                          this.savePolicy().then(
                            msg =>
                              toast.success('Great! The E&O policy has been updated.', {
                                position: toast.POSITION.TOP_RIGHT,
                              }),
                            err =>
                              toast.error(`${err}`, {
                                position: toast.POSITION.TOP_RIGHT,
                              })
                          )
                        }}
                      >
                        {isSaving ? (
                          <>
                            <i className='fa fa-spin fa-spinner'></i> Saving ...
                          </>
                        ) : (
                          'Save E&O Policy'
                        )}
                      </MDBBtn>
                    </MDBCol>
                  </MDBRow>
                </MDBCol>
              ) : (
                <div className='eo-loading-spinner'>
                  <LoadingSpinner size='sm' isActive={true} label={'E&O Records'} />
                </div>
              )}
            </MDBRow>
            <MDBRow>
              <MDBCol size='12'>
                <CustomAlert color='warning'>
                  <strong>Note:</strong> This utility will update the E&O Policy for all Signature Agents & above. This
                  will not overwrite personally submitted policies.
                </CustomAlert>
              </MDBCol>
            </MDBRow>
          </form>
        </main>
      </DashboardLayout>
    )
  }
}

export default AdminEOPolicyPage
